import { Page } from "../../components/common";
import { Trans, useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useClient } from "../../hooks";
import { useEffect } from "react";
import { Alert } from "reactstrap";
import { SIGN_UP_WITH_XERO_AUTHORIZE_URL } from "./constants";
export const SignUpWithXeroRedirect = () => {
  const client = useClient();
  const { mutate, error } = useMutation({
    mutationFn: () =>
      client.get(SIGN_UP_WITH_XERO_AUTHORIZE_URL).get("data").get("url"),
    onSuccess: (url) => (window.location.href = url),
    useErrorBoundary: false,
  });
  const { t } = useTranslation();

  useEffect(() => {
    mutate([]);
  }, [mutate]);

  return (
    <Page title={t("Sign up with Xero")} translate={false}>
      {error ? (
        <Alert color="danger" className="text-center">
          <Trans>An error occurred, please try again.</Trans>
        </Alert>
      ) : (
        <div className="text-muted text-center">
          <span className="fa fa-spinner fa-spin mr-2" />{" "}
          <Trans>Please wait while we redirect to Xero...</Trans>
        </div>
      )}
    </Page>
  );
};
